import {
  type FetchTariffListParams,
  fetchTariffs
} from 'Services/ProductManagement/Features/Tariff/tariffSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

function useTariffsWithParams() {
  const dispatch = useAppDispatch()
  const { tariffs, loading, total_results, next_page, previous_page } = useTypedSelector(
    state => state.tariff
  )

  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchTariffListParams>({
    filter: searchParams.get('filter') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'tariffCode',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    setSearchParams(searchParams)
  }

  useEffect(() => {
    dispatch(fetchTariffs(params))
    setQueryParams()
  }, [params])

  return {
    tariffs,
    loading,
    params,
    setParams,
    total_results,
    next_page,
    previous_page
  }
}

export default useTariffsWithParams
